import client from './client';

export function getFeedbackCapabilities() {
  return client.get('/api/feedback/capabilities');
}

export function getFeedbackOptions() {
  return client.get('/api/feedback/options');
}

export function listFeedbackEntries(topicKey, sortKey) {
  return client.get('/api/feedback', {
    params: {
      topic: topicKey,
      sortKey,
    },
  });
}

export function getFeedbackEntry(id) {
  return client.get(`/api/feedback/${id}`);
}

export function createFeedbackEntry(payload) {
  return client.post('/api/feedback', payload);
}

export function updateFeedbackEntry(id, payload) {
  return client.put(`/api/feedback/${id}`, payload);
}

export function deleteFeedbackEntry(id) {
  return client.delete(`/api/feedback/${id}`);
}

export function uploadFeedbackAssets(id, files) {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));
  return client.post(`/api/feedback/${id}/assets`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function deleteFeedbackAsset(entryId, assetId) {
  return client.delete(`/api/feedback/${entryId}/assets/${assetId}`);
}

export function updateFeedbackStatus(id, payload) {
  if (typeof payload === 'string') {
    return client.patch(`/api/feedback/${id}/status`, { status: payload });
  }

  return client.patch(`/api/feedback/${id}/status`, payload);
}

export function updateFeedbackDisplayColor(id, displayColor) {
  return client.patch(`/api/feedback/${id}/display-color`, { displayColor });
}

export function getFeedbackAssetBlob(entryId, assetId, download = false) {
  return client.get(`/api/feedback/${entryId}/assets/${assetId}/${download ? 'download' : 'content'}`, {
    responseType: 'blob',
  });
}
